import { Checkbox } from '@mui/material';
import React from 'react'
import { FaRegCircleDot } from 'react-icons/fa6';

const FormSection = ({ title, children }) => {
  return (
    <div className="bg-white p-2 mb-6">
      {title && (
        <div className="flex items-center mb-4 rounded-lg border text-[#1C3664]">
          <Checkbox
            icon={<FaRegCircleDot />}
            disabled
            style={{ color: "#1C3664" }}
          />
          <h3 className="text-lg p-2 font-semibold ">{title}</h3>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 p-2">
        {children}
      </div>
    </div>
  );
};

export default FormSection